import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactResizeDetector from 'react-resize-detector';

import Input from '../../components/formElements/Input';

import { MobileTabletOnly, DesktopUp } from 'shared/Responsive';
import ScrollSpy from '../../../../shared/ScrollSpy';

class IndexSearch extends Component {
  domElement;

  constructor(props) {
    super(props);

    this.state = {
      height: undefined
    };
  }

  render() {
    const scrollSpyDefaultProps = {
      className: 'index-search__letters',
      items: this.props.letters.map(l => `letter-group-${l.toLowerCase()}`)
    };

    return (
      <div id={this.props.id} className="index-search" ref={c => this.domElement = c}>
        <ReactResizeDetector handleHeight onResize={this.handleResize.bind(this)} />

        <div className="container">
          <MobileTabletOnly>
            <ScrollSpy { ...scrollSpyDefaultProps } offset={this.state.height}>{ this.scrollSpyLinks() }</ScrollSpy>
          </MobileTabletOnly>

          <DesktopUp>
            <ScrollSpy { ...scrollSpyDefaultProps } offset={this.state.height + 40}>{ this.scrollSpyLinks() }</ScrollSpy>
          </DesktopUp>

          <div className="index-search__search">
            <Input className="input--white" type="search" onChange={this.props.onSearch} />
          </div>
        </div>
      </div>
    );
  }

  scrollSpyLinks() {
    return (
      <React.Fragment>
        { this.props.letters && this.props.letters.map((letter) => (
          <a
            key={letter.toLowerCase()}
            href={`#letter-group-${letter.toLowerCase()}`}
            className="index-search__letters__item"
          >
            { letter}
          </a>
        ))}
      </React.Fragment>
    );
  }

  handleResize() {
    // Component's height might change depending on the user's screen size and whether or not they resized the window,
    // and this height will be needed as an offset to scroll to. Currently used by the ScrollSpy component.
    this.setState({
      height: parseInt(window.getComputedStyle(this.domElement).height)
    });
  }
}

IndexSearch.defaultProps = {
  id: ''
};
IndexSearch.propTypes = {
  id: PropTypes.string,
  letters: PropTypes.array,
  onSearch: PropTypes.func
};

export default IndexSearch;
